import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getCourseProgress } from '../../../../Utilities/api';
import { useUserDefaultCourse } from './useUserDefaultCourse';
import { AdminRoutesContext } from '../AdminRoutesContext';
export const useCourseProgress = (courseUuid) => {
    const { isPreviewMode } = useContext(AdminRoutesContext);
    const { isLoading: isDefaultCourseLoading, data: defaultCourseData } = useUserDefaultCourse();
    const effectiveCourseUuid = courseUuid || defaultCourseData?.uuid;
    return useQuery({
        queryKey: ['courseProgress', effectiveCourseUuid],
        queryFn: () => getCourseProgress(effectiveCourseUuid),
        enabled: !isPreviewMode && !!effectiveCourseUuid && !isDefaultCourseLoading,
    });
};
